/**
 * RED THEME
 */
export const THEMES = {
  description:
    "TYPE: CUSTOM\nMaterial Theme Builder export 2024-02-23 05:21:22",
  seed: "#7C2826",
  coreColors: {
    primary: "#7C2826",
  },
  constants: { menuIconActive: "#FFF8F7", menuIconInactive: "#FFEDEB" },
  extendedColors: [],
  schemes: {
    light: {
      primary: "#904A46",
      surfaceTint: "#904A46",
      onPrimary: "#FFFFFF",
      primaryContainer: "#FFDAD7",
      onPrimaryContainer: "#3B0909",
      secondary: "#775654",
      onSecondary: "#FFFFFF",
      secondaryContainer: "#FFDAD7",
      onSecondaryContainer: "#2C1513",
      tertiary: "#725B2E",
      onTertiary: "#FFFFFF",
      tertiaryContainer: "#FFDEA6",
      onTertiaryContainer: "#271900",
      error: "#BA1A1A",
      onError: "#FFFFFF",
      errorContainer: "#FFDAD6",
      onErrorContainer: "#410002",
      background: "#FFF8F7",
      onBackground: "#231919",
      surface: "#FFF8F7",
      onSurface: "#231919",
      surfaceVariant: "#F5DDDB",
      onSurfaceVariant: "#534342",
      outline: "#857371",
      outlineVariant: "#D8C2BF",
      shadow: "#000000",
      scrim: "#000000",
      inverseSurface: "#382E2D",
      inverseOnSurface: "#FFEDEB",
      inversePrimary: "#FFB3AE",
      primaryFixed: "#FFDAD7",
      onPrimaryFixed: "#3B0909",
      primaryFixedDim: "#FFB3AE",
      onPrimaryFixedVariant: "#733330",
      secondaryFixed: "#FFDAD7",
      onSecondaryFixed: "#2C1513",
      secondaryFixedDim: "#E7BDB9",
      onSecondaryFixedVariant: "#5D3F3D",
      tertiaryFixed: "#FFDEA6",
      onTertiaryFixed: "#271900",
      tertiaryFixedDim: "#E1C28C",
      onTertiaryFixedVariant: "#594319",
      surfaceDim: "#E8D6D4",
      surfaceBright: "#FFF8F7",
      surfaceContainerLowest: "#FFFFFF",
      surfaceContainerLow: "#FFF0EF",
      surfaceContainer: "#FCEAE8",
      surfaceContainerHigh: "#F6E4E2",
      surfaceContainerHighest: "#F1DEDD",
      backdropColor: "#00000099",
      backdropColor2: "#0000001A",
    },
    dark: {
      primary: "#FFB3AE",
      surfaceTint: "#FFB3AE",
      onPrimary: "#571E1B",
      primaryContainer: "#733330",
      onPrimaryContainer: "#FFDAD7",
      secondary: "#E7BDB9",
      onSecondary: "#442927",
      secondaryContainer: "#5D3F3D",
      onSecondaryContainer: "#FFDAD7",
      tertiary: "#E1C28C",
      onTertiary: "#402D04",
      tertiaryContainer: "#594319",
      onTertiaryContainer: "#FFDEA6",
      error: "#FFB4AB",
      onError: "#690005",
      errorContainer: "#93000A",
      onErrorContainer: "#FFDAD6",
      background: "#1A1111",
      onBackground: "#F1DEDD",
      surface: "#1A1111",
      onSurface: "#F1DEDD",
      surfaceVariant: "#534342",
      onSurfaceVariant: "#D8C2BF",
      outline: "#A08C8A",
      outlineVariant: "#534342",
      shadow: "#000000",
      scrim: "#000000",
      inverseSurface: "#F1DEDD",
      inverseOnSurface: "#382E2D",
      inversePrimary: "#904A46",
      primaryFixed: "#FFDAD7",
      onPrimaryFixed: "#3B0909",
      primaryFixedDim: "#FFB3AE",
      onPrimaryFixedVariant: "#733330",
      secondaryFixed: "#FFDAD7",
      onSecondaryFixed: "#2C1513",
      secondaryFixedDim: "#E7BDB9",
      onSecondaryFixedVariant: "#5D3F3D",
      tertiaryFixed: "#FFDEA6",
      onTertiaryFixed: "#271900",
      tertiaryFixedDim: "#E1C28C",
      onTertiaryFixedVariant: "#594319",
      surfaceDim: "#1A1111",
      surfaceBright: "#423736",
      surfaceContainerLowest: "#140C0B",
      surfaceContainerLow: "#231919",
      surfaceContainer: "#271D1C",
      surfaceContainerHigh: "#322827",
      surfaceContainerHighest: "#3D3231",
      backdropColor: "#00000099",
      backdropColor2: "#0000001A",
    },
  },
  palettes: {
    primary: {
      0: "#000000",
      5: "#2D0002",
      10: "#410004",
      15: "#51070A",
      20: "#601314",
      25: "#6F1E1D",
      30: "#7E2A28",
      35: "#8E3532",
      40: "#9D413D",
      50: "#BC5853",
      60: "#DC716B",
      70: "#FC8B83",
      80: "#FFB3AE",
      90: "#FFDAD7",
      95: "#FFEDEB",
      98: "#FFF8F7",
      99: "#FFFBFF",
      100: "#FFFFFF",
    },
    secondary: {
      0: "#000000",
      5: "#200A09",
      10: "#2D1513",
      15: "#381F1D",
      20: "#442927",
      25: "#513432",
      30: "#5D3F3D",
      35: "#6A4A48",
      40: "#775653",
      50: "#926E6B",
      60: "#AE8884",
      70: "#CAA29E",
      80: "#E7BCB9",
      90: "#FFDAD7",
      95: "#FFEDEB",
      98: "#FFF8F7",
      99: "#FFFBFF",
      100: "#FFFFFF",
    },
    tertiary: {
      0: "#000000",
      5: "#190F00",
      10: "#271900",
      15: "#342300",
      20: "#402D04",
      25: "#4C380D",
      30: "#594318",
      35: "#664F23",
      40: "#735B2D",
      50: "#8D7343",
      60: "#A98D5A",
      70: "#C5A772",
      80: "#E2C28B",
      90: "#FFDEA6",
      95: "#FFEFD7",
      98: "#FFF8F3",
      99: "#FFFBFF",
      100: "#FFFFFF",
    },
    neutral: {
      0: "#000000",
      5: "#15100F",
      10: "#201A1A",
      15: "#2B2424",
      20: "#362F2E",
      25: "#413A39",
      30: "#4D4544",
      35: "#595050",
      40: "#655C5B",
      50: "#7F7574",
      60: "#998E8D",
      70: "#B4A9A7",
      80: "#D0C4C2",
      90: "#EDE0DE",
      95: "#FBEEEC",
      98: "#FFF8F7",
      99: "#FFFBFF",
      100: "#FFFFFF",
    },
    "neutral-variant": {
      0: "#000000",
      5: "#190E0D",
      10: "#251918",
      15: "#302321",
      20: "#3B2D2C",
      25: "#473837",
      30: "#534342",
      35: "#5F4F4D",
      40: "#6B5A59",
      50: "#857371",
      60: "#A08C8A",
      70: "#BBA6A5",
      80: "#D8C2BF",
      90: "#F5DDDB",
      95: "#FFEDEB",
      98: "#FFF8F7",
      99: "#FFFBFF",
      100: "#FFFFFF",
    },
  },
};
